import React from 'react';

// Steps block — an ORDERED "how it works" / process list (semantic <ol>). Presentation only.
// Reusable across Airport/Station transfers, Recruitment ("how to apply"), Partner ("how to join"),
// booking explainers, etc.
export default function Steps({ heading, steps }) {
  return (
    <section className="mb-10">
      {heading ? (
        <h2 className="mb-6 font-heading text-2xl font-bold text-black">{heading}</h2>
      ) : null}
      <ol className="space-y-5">
        {steps.map((s, i) => (
          <li key={i} className="flex gap-4">
            <span
              aria-hidden="true"
              className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-black text-sm font-semibold text-white"
            >
              {i + 1}
            </span>
            <div>
              <h3 className="font-semibold text-black">{s.title}</h3>
              <p className="text-sm text-neutral-600">{s.text}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
